import { Component, input, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-youtube-player",
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="youtube-player-container">
      <lite-youtube
        [attr.videoid]="videoId()"
        [attr.params]="params()"
      ></lite-youtube>
    </div>
  `,
  styleUrls: ["./youtube-player.component.scss"],
})
export class YouTubePlayerComponent {
  // Input principal: ID del video (requerido)
  videoId = input.required<string>();

  // Inputs opcionales con valores por defecto
  width = input<string | number>("100%");
  height = input<string | number>(450);
  playLabel = input<string>("Reproducir video");
  params = input<string>("");

  // Método utilitario para extraer el ID de una URL completa de YouTube
  static extractVideoId(url: string): string | null {
    if (!url) return null;

    // Si ya es solo el ID (11 caracteres), devolverlo directamente
    if (url.length === 11 && /^[a-zA-Z0-9_-]+$/.test(url)) {
      return url;
    }

    // Extraer ID de URL completa
    const regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }
}
